import { BasicConstants } from "../basic/constants/BasicConstants";

/**
 * @author dkoehler
 *
 * predefined constants for external logger
 */
export class ExternalLoggingConstants {
    public static LOG_LOADER_NAME: string = "logLoader";
    public static LOG_API_URL: string = BasicConstants.DOMAIN_PROTOCOL + "://logging.goodgamestudios.com";

    //----------------------------------
    //	Log Type And Object IDs for Error Log
    //----------------------------------
    /** identifies this logger as flash-logger for server */
    public static LOGGING_TYPE_ERROR: number = 3;

    //----------------------------------
    //	Log Type And Object IDs for Debug Log
    //----------------------------------
    /** identifies this logger as flash-logger for server */
    public static LOGGING_TYPE_LOG: number = 7;

    //----------------------------------
    //	Log Params
    //----------------------------------
    public static PARAM_LOG_TYPE: string = "type";
    public static PARAM_LOG_EVENT_ID: string = "eventId";
    public static PARAM_SUB_ERROR_ID: string = "subErrorId";

    public static PARAM_SESSION_ID: string = "sessionId";
    public static PARAM_GAME_ID: string = "gameId";
    public static PARAM_NETWORK_ID: string = "networkId";
    public static PARAM_ZONE: string = "zone";
    public static PARAM_INSTANCE: string = "instance";
    public static PARAM_COUNTRY_CODE: string = "countryCode";
    public static PARAM_LANGUAGE_CODE: string = "selectedLanguage";
    public static PARAM_ACCOUNT_ID: string = "accountId";
    public static PARAM_PLAYER_ID: string = "playerId";
    public static PARAM_IS_FIRST_VISIT_OF_GGS: string = "isFirstVisitOfGGS";
    public static PARAM_URL: string = "url";
    public static PARAM_UTC_TIME_STAMP: string = "utcTimeStamp";
    public static PARAM_SESSION_LENGTH: string = "sessionLength";
    public static PARAM_ERROR_EVENT_OPERATION_TEXT: string = "errorEventOperationText";
    public static PARAM_CDN: string = "cdn";
    public static PARAM_NULL_PARAMETER_NAME: string = "nullParameterName";
    public static PARAM_AFFECTED_FUNCTION_NAME: string = "affectedFunctionName";
    public static PARAM_AVAILABLE_SPACE_ON_DEVICE: string = "availableSpaceOnDevice";
    public static PARAM_AVAILABLE_CACHE_ON_DEVICE: string = "availableCacheOnDevice";
    public static PARAM_AVAILABLE_APPLICATION_STORAGE_SPACE: string = "availableApplicationStorageSpace";
    public static PARAM_CLIENT_TYPE: string = "clientType";
    public static PARAM_PERFORMANCE_CATEGORY: string = "performanceCategory";

    public static PARAM_HTTP_USER_AGENT: string = "httpUserAgent";
    public static PARAM_HTTP_PLATFORM: string = "httpPlatform";
    public static PARAM_HTTP_VENDOR: string = "httpVendor";

    // Mobile
    public static PARAM_SOURCESTORE: string = "sourceStore";
    public static PARAM_DEVICETYPE: string = "deviceType";
    public static PARAM_DEVICECATEGORY: string = "deviceCategory";
    public static PARAM_OS: string = "os";
    public static PARAM_CLIENT_VERSION: string = "clientVersion";
    public static PARAM_ITEM_XML_VERSION: string = "itemXMLVersion";
    public static PARAM_IS_IN_BACKGROUND: string = "isInBackground";
    public static PARAM_CONNECTION_TYPE: string = "connectionType";
    public static PARAM_IS_FIRST_APP_START_AFTER_UPDATE: string = "isFirstAppStartAfterUpdate";

    // Web
    public static PARAM_HTTP_REFERER: string = "httpReferer";

    // HTML5
    public static PARAM_HTML5_TAG: string = "tag";
}
